import companyLogo from 'assets/funnel/powerserv_logo_2.png';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

// TODO: replace with lenze_918-specific images
import heroImg from 'assets/funnel/lenze_918_1.jpg';
import infoHeroImg from 'assets/funnel/lenze_918_2.jpg';
import jobDetailsImg from 'assets/funnel/lenze_918_3.jpg';
import groupImg from 'assets/funnel/lenze_918_4.jpg';

const lenze_918 = {
  documentTitle: "Produktionsmitarbeiter (m/w/d) – Sicherer Job & Top-Schichtzulagen | POWERSERV Austria GmbH",
  companyLogo,
  companyName: "POWERSERV Austria GmbH",
  aiDisclaimer,

  landing: {
    heroImg,
    chipText: "Vollzeit · €2.900 / Monat · Asten",
    heroTitle: "Produktionsmitarbeiter (m/w/d) · Montage · Vollzeit",
    heroSubtitle: "Wir suchen motivierte Produktionsmitarbeiter (m/w/d) für ein modernes Unternehmen in Asten, Oberösterreich.",
    facts: [
      { icon: 'bi-cash-stack',   title: '€ 2.900,– / Monat',       subtitle: 'Brutto-Mindestlohn + Überzahlung möglich' },
      { icon: 'bi-geo-alt-fill', title: 'Asten',                    subtitle: 'Standort · Oberösterreich' },
      { icon: 'bi-clock',        title: '2- und 3-Schichtbetrieb',  subtitle: 'Attraktive Schichtzulagen' },
      { icon: 'bi-shield-check', title: 'Sicherer Arbeitsplatz',    subtitle: 'Langfristige Perspektive' },
    ],
  },

  info: {
    heroImg: infoHeroImg,
    heroChip: "Vollzeit · Produktion & Montage",
    heroTitleLines: ["Produktionsmitarbeiter", "(m/w/d)"],
    facts: [
      { value: "€ 2.900", label: "Brutto-Mindestlohn + Überzahlung möglich" },
      { value: "Vollzeit", label: "Asten, Oberösterreich" },
    ],
    moechtestDuItems: [
      { icon: 'bi-tools',      text: 'Baugruppen montieren und technische Komponenten zusammenbauen – handwerklich und präzise?' },
      { icon: 'bi-search',     text: 'Qualitäts- und Funktionskontrollen durchführen und aktiv zur Produktqualität beitragen?' },
      { icon: 'bi-graph-up',   text: 'in einem stabilen Unternehmen mit attraktiven Schichtzulagen und echter langfristiger Perspektive durchstarten?' },
    ],
    benefits: [
      { icon: 'bi-shield-check',  title: 'Sicherer Arbeitsplatz',          desc: 'Langfristige Vollzeitstelle in einem stabilen Unternehmen.' },
      { icon: 'bi-building',      title: 'Modernes Arbeitsumfeld',          desc: 'Strukturierte Einschulung in einem modernen Produktionsbetrieb.' },
      { icon: 'bi-people',        title: 'Kollegiales Team',                desc: 'Angenehmes Betriebsklima in einem eingespielten, unterstützenden Team.' },
      { icon: 'bi-signpost-2',    title: 'Gute Erreichbarkeit',             desc: 'Direkte Autobahnanbindung – bequem erreichbar mit dem Auto.' },
      { icon: 'bi-cup-hot',       title: 'Kantine & Schichtzulagen',        desc: 'Betriebskantine vor Ort und attraktive Zulagen für Schichtarbeit.' },
      { icon: 'bi-book',          title: 'Weiterbildung & Entwicklung',     desc: 'Weiterbildungsmöglichkeiten und Entwicklungsperspektiven im Unternehmen.' },
      { icon: 'bi-tag',           title: 'Mitarbeiterrabatte',              desc: 'Attraktive Rabatte bei namhaften Kooperationspartnern.' },
    ],
    aufgabenTitle: "Montage mit System.",
    tasks: [
      'Montage von Baugruppen nach Vorgaben',
      'Zusammenbau und Bearbeitung technischer Komponenten',
      'Durchführung von Qualitäts- und Funktionskontrollen',
      'Arbeiten nach Arbeitsanweisungen und technischen Unterlagen',
      'Dokumentation und einfache Dateneingaben',
    ],
    requirements: [
      'Erfahrung in Produktion oder Montage von Vorteil',
      'Technisches Verständnis und handwerkliches Geschick',
      'Bereitschaft zur Schichtarbeit (2- und 3-Schicht)',
      'Grundkenntnisse im Umgang mit dem PC',
      'Zuverlässige, genaue und teamorientierte Arbeitsweise',
    ],
    jobDetailsImg,
    jobDetailsTagLines: ["Montage &", "Produktion"],
    noteText: "Technik begeistert dich und du arbeitest gerne praktisch? Dann bist du bei uns genau richtig – wir freuen uns auf deine Bewerbung.",
    groupImg,
    finalCtaTitle: "Dann bist du bei uns genau richtig!",
    finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
  },

  quiz: {
    handshakeImg,
  },
};

export default lenze_918;
